<template>
  <div class="chapterOne">
      L03 练习4 定义，定义<br>
　　【问题描述】<br>
　　考察关于AI的以下三个定义：<br>
　　“计算机无法做到的很酷的事情”<br>
　　模仿人类智能行为的机器<br>
　　自主和自适应系统<br>
　　1.指出它们优缺点，用几句话来表达您的评价。<br>
　　2.提出您自己的改进定义，以解决您在上述考察中发现的一些问题。<br>
　　【参考答案】<br>
　　答案没有对错之分，但我们认为：<br>
　　1.“电脑做不到的酷事”<br>
　　优点：这适应了包括未来新问题在内的人工智能，捕捉了广泛的计算机视觉、自然语言处理等人工智能。<br>
　　缺点：它排除了任何“解决”的问题，很难说什么算“酷”。<br>
　　2.“模仿人类智能行为的机器”<br>
　　优点：和前面一样，模仿也是一个好词，因为它不要求人工智能解决方案应该是“智能”的（无论它是什么意思），而是足够聪明地行动。<br>
　　缺点：这个定义几乎是自指的，因为它立即导致了“智能”是什么的问题，而且这个定义太狭隘了，因为它只包括类似人类的智能行为，而排除了其他形式的智能，如所谓的群体智能（例如蚁群展示的智能）。<br>
　　3.“自主和自适应系统”<br>
　　优点：它突出了人工智能的两个主要特点，捕捉了机器人、自动驾驶汽车等，也很适合基于机器学习的人工智能方法，能够适应训练数据。<br>
　　缺点：再一次，这些问题导致了进一步的问题，尤其是“自主”的定义不是很清楚（吸尘器机器人是自主的吗？垃圾邮件过滤器怎么样？）；此外，并非所有的人工智能系统都需要自治，事实上，我们通常可以通过将人类和机器智能结合起来实现更多的功能。<br>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods:{

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chapterOne{
    width: 650px;
    margin: 0 auto;
    padding: 0px 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/referenceAnswer.vue